require("../../assets/lib/master-slider/source/assets/css/masterslider.main.css");

require("../../assets/unify/css/pages/page_search.css");
require("../../assets/unify/css/pages/page_log_reg_v1.css");

require('../../node_modules/pikaday/css/pikaday.css');


// WEBPACK FOOTER //
// ./webpack/index/css.js